// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Upm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000051.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>中北非国际教育创新联盟</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>中欧全球南方文化教育联盟</div>
                            </div>
                            {this.state.currentTab == 0 && <div>

                                <LazyImage imgUrl={require("./assets/img/convoy/55_000088.jpg")} />
                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000089.jpg")} />
                            </div>}


                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Upm);